// Use this function instead of isEmpty from package dna-common
export const isEmptyOrSpaces = (str: string | null | undefined): boolean => {
    return str === null || str === undefined || String(str).trim() === ''
}
